// import React from 'react';
import { ChevronRight } from 'lucide-react';
import {
    Dialog,
    DialogTrigger,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogFooter,
    DialogClose,
} from './dialog';
import { Button } from './button';

const LogoutDialog = ({ onConfirm }) => {
    return (
        <Dialog>
            <DialogTrigger asChild>
                <li className="px-2 py-1 text-neutral-700 hover:text-primary hover:bg-neutral-200 cursor-pointer">
                    <button className="flex items-center justify-between w-full">
                        <span>Logout</span>
                        <ChevronRight size={20} />
                    </button>
                </li>
            </DialogTrigger>
            <DialogContent className="border-neutral-300 px-5 py-4">
                <DialogHeader>
                    <DialogTitle>Are you absolutely sure?</DialogTitle>
                    <DialogDescription className="mb-4 mt-4">
                        This action will log you out of your account.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className={'flex flex-col gap-4'}>
                    <DialogClose asChild>
                        <Button variant="outline">Cancel</Button>
                    </DialogClose>
                    <Button onClick={onConfirm} variant="destructive">
                        Logout
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default LogoutDialog;
